import { FC } from 'react'

import useCatalogArtworkData from '../../hooks/useCatalogArtworkData'
import { useModuleContext } from '../../contexts/ArtistContext'
import useSortOptions from '../../hooks/useSortBy'

import { useRouter } from 'next/router'
import CatalogueArtworkItem from '@components/reusable-modules/common/CatalogueArtworksList'

const CatalogueArtworkView: FC = () => {
  useCatalogArtworkData()
  const { state: {
    catalogArtworksList,
    isLoadingNewpage,
    isLoadingList,
    CMSProps,
    //@ts-ignore
    labels
  },
    refs, dispatch
  } = useModuleContext()
  const { options, currentOrderBy } = useSortOptions()
  const router = useRouter()
  const [sortBy, direction, groupBy] = currentOrderBy.split('|')

  return (
    <CatalogueArtworkItem
      sortByLabel={CMSProps.pro2_grp1_label_sortby}
      selectedValue={currentOrderBy}
      options={options}
      handleChange={(value) => {
        if (router.query.orderBy) {
          delete router.query.orderBy
        }
        router.push({
          pathname: '/',
          query: {
            orderBy: value,
            activeTab: router.query.activeTab
          }
        }, `${router.asPath}`,
          { shallow: true })
      }}
      isItemsLoading={isLoadingList}
      total={refs && refs?.paginationInfo?.current && refs.paginationInfo.current.total}
      totalItemsLabel={CMSProps.pro2_grp1_paging_suffix}
      //@ts-ignore
      list={catalogArtworksList}
      groupBy={groupBy}
      sortBy={sortBy}
      direction={direction}
      isLoadingNewpage={isLoadingNewpage}
      handleShowMore={() => {
        dispatch({ type: 'SET_IS_LOADING_MORE_ITEM', payload: true })
        refs?.loadNextPageRef?.current()
      }}
      hideShowMoreButton={refs?.paginationInfo?.current && !refs.paginationInfo.current.hasMore}
      noItemsAvailableLabel='No Artworks available for this Artist'
      labels={labels}
      isCatalogueArtwork
    />
  )
}

export default CatalogueArtworkView
